module.exports = "/_next/static/chromiums/og-1200x630-planet-8927786c6979d55248ff180f61c76034.jpg";